import {Component, Input, OnInit} from '@angular/core';
import {ApplicantRequestService} from '../../../service/applicant-request.service';

@Component({
  selector: 'app-card-preview-popup',
  templateUrl: './card-preview-popup.component.html',
  styleUrls: ['./card-preview-popup.component.scss']
})
export class CardPreviewPopupComponent implements OnInit {
  @Input() applicationId: number;
  @Input() fromParent;
  isLoading: boolean = false;

  constructor(private applicantRequestService: ApplicantRequestService) { }

  ngOnInit() {
  }

  view() {
    this.isLoading = true;
    this.applicantRequestService.cardPreview(this.fromParent.application).subscribe(
      (data: any) => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = fileURL;
        document.body.appendChild(iframe);
        iframe.contentWindow.print();
        this.isLoading = false;

      },
      error => {
        this.isLoading = false;
        console.log(error);
      }
    );
  }
}
